import { Box, Flex, Container } from '@chakra-ui/react'
import { Outlet } from 'react-router-dom'
import SidebarNav from './SidebarNav'
import TopBar from './TopBar'
import OverviewStrip from './OverviewStrip'

const DashboardShell = () => {
  const stats = [
    { label: '观察标的', value: '—' },
    { label: '未平仓', value: '—' },
    { label: '今日交易', value: '—' },
    { label: '风险提示', value: '—' },
  ]

  return (
    <Flex minH="100vh" bg="bg.canvas">
      {/* Sidebar - Fixed width, border right */}
      <Box
        w={{ base: '0', md: '240px' }}
        display={{ base: 'none', md: 'block' }}
        borderRight="1px solid"
        borderColor="border.subtle"
        bg="bg.canvas"
        position="sticky"
        top="0"
        h="100vh"
        overflowY="auto"
      >
        <SidebarNav />
      </Box>

      {/* Main Content Area */}
      <Flex flex="1" direction="column" minW="0">
        {/* Top Header */}
        <Box
          position="sticky"
          top="0"
          zIndex="10"
          bg="bg.canvas/80" // approximate translucent
          backdropFilter="blur(12px)"
          borderBottom="1px solid"
          borderColor="border.subtle"
          px={6}
          py={3}
        >
          <TopBar />
        </Box>

        {/* Scrollable Content */}
        <Box flex="1" px={{ base: 4, md: 8 }} py={6}>
            <OverviewStrip stats={stats} />
            <Box mt={6}>
                <Outlet />
            </Box>
        </Box>
      </Flex>
    </Flex>
  )
}

export default DashboardShell
